export default "__VITE_ASSET__09fc84ba__"